import { CreateOrganizationEndAction } from "../actions/CreateOrganization";
import { OrgState } from "../state";
import { appendToLastPage } from "./Common";

import { union } from "utils/Utils";

export function createOrganization(state: OrgState, action: CreateOrganizationEndAction) {
    // Just append it to the last page.
    const { error, organization, selectOnSuccess } = action.payload;
    const newState: Partial<OrgState> = { error };
    newState.orgs = union(state.orgs, organization, "organizationId");
    newState.orgPages = appendToLastPage(state, organization);

    if (selectOnSuccess) {
        newState.currentOrg = organization;
        newState.currentPaymentSummary = undefined;
        newState.currentAvailableAppsSummary = undefined;
    }
    return { ...state, ...newState };
}
